export default __webpack_public_path__ + "static/media/018-rain.d6c651dc.svg";